/**
 * 递归对数据做 URL 解码 + JSON 解析。
 * 后端 newHouse 业务接口的 data 整体是 JSON 格式的 URL 编码字符串，
 * 前端渲染前先 URL 解码，再尝试 JSON.parse 成对象。
 *
 * - 数组：逐项递归
 * - 对象：遍历字段递归
 * - 字符串：先 decodeURIComponent，再尝试 JSON.parse 成对象/数组；
 *   不是合法 JSON 就保留原字符串
 * - 其他类型（数字、布尔、null）：原样返回
 */
export const decodeData = (val) => {
  if (Array.isArray(val)) {
    return val.map(decodeData);
  }
  if (val && typeof val === 'object') {
    return Object.keys(val).reduce((acc, k) => {
      acc[k] = decodeData(val[k]);
      return acc;
    }, {});
  }
  if (typeof val === 'string') {
    let decoded = val;
    try {
      decoded = decodeURIComponent(val);
    } catch (e) {
      decoded = val;
    }
    // 尝试按 JSON 解析；成功就当对象/数组继续递归，失败就保留字符串
    const trimmed = decoded.trim();
    if (
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']'))
    ) {
      try {
        return decodeData(JSON.parse(trimmed));
      } catch (e) {
        return decoded;
      }
    }
    return decoded;
  }
  return val;
};
